import { userProfileConstants } from '../../_constants';
import swal from 'sweetalert2';

const initialState = { updateBasicInfoLoading: true, data: '', error: false };

export function updateBasicInfo(state = initialState, action) {
    
    switch (action.type) {
        case userProfileConstants.REQUEST_UPDATE_BASIC_PROFILE:
            return {
                updateBasicInfoLoading: true,
                data: '',
                error: false
            };
        case userProfileConstants.RECEIVE_UPDATE_BASIC_PROFILE:
        swal({
            text: 'User Basic Profile Updated Successfully',
            type: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
            return {
                updateBasicInfoLoading: false,
                data: action.getUserProfile,
                error: false
            };
        case userProfileConstants.UPDATE_BASIC_PROFILE_ERROR:
        swal({
            text: 'Error in updating user profile',
            type:'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
        })
            return {
                updateBasicInfoLoading: false,
                data: action.error,
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/userProfile/updateBasicInfo.reducer.js